import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const CampaignSale = React.lazy(() =>
    import('../CampaignSale')
);
const campaignSaleRoutesRegistry = [
    {
        path: PAGE_URL.CAMPAIGN_SALE_PAGE,
        element: <CampaignSale />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default campaignSaleRoutesRegistry;
